<template>
  <button
    v-if="selection !== path.pass"
    class="path-tile"
    :style="`background-image: url(${$getPlaylistBackground(path.objectID)});`"
    @click="onLPClickHandler()"
  >
    <!-- <div class="path-tile__mask"></div> -->
    <div class="path-tile__content">
      <div class="path-tile__badge">
        <Passes :passName="path.pass" :size="70" />
      </div>
      <div class="path-tile__title-wrapper">
        <div class="path-tile__title">{{ path.pass }}</div>
        <div class="path-tile__title--subtitle">{{ path.name }}</div>
        <ArrowRightIcon class="path-tile__arrow" />
      </div>
    </div>
  </button>
</template>

<script>
import Passes from '@/components/properties/Passes.vue'
import { ArrowRightIcon } from 'vue-feather-icons'

export default {
  name: 'StaticLPTile',
  components: {
    Passes,
    ArrowRightIcon,
  },
  props: {
    path: {
      type: Object,
      required: true,
    },
    selection: {
      type: String,
      required: true,
    },
  },
  methods: {
    onLPClickHandler() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      setTimeout(this.$emit('update-selection', this.path.pass), 5000)
    },
  },
}
</script>

<style lang="scss" scoped>
.path-tile {
  width: 100%;
  height: 365px;
  border: none;
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0;
  margin-bottom: 20px;
  cursor: pointer;
  @include tablet {
    margin-right: 20px;
    max-width: 335px;
  }
  &:hover {
    .path-tile {
      &__content {
        background: linear-gradient(
          91deg,
          var(--light-gray-darker) -100%,
          var(--dark-gray) 60%
        );
      }
      &__arrow {
        stroke: var(--white);
        width: 26px;
        height: 26px;
        margin-right: 0;
      }
    }
  }
  &:active {
    .path-tile {
      &__content {
        background: linear-gradient(
          91deg,
          var(--light-gray) -100%,
          var(--dark-gray) 60%
        );
      }
      &__arrow {
        stroke: var(--white);
        margin-right: 0;
      }
    }
  }
  &__content {
    width: 100%;
    height: 184px;
    position: relative;
    top: 92px;
    border-radius: 0 0 10px 10px;
    background: linear-gradient(
      91deg,
      var(--light-gray) -100%,
      var(--dark-gray) 60%
    );
  }
  &__badge {
    position: relative;
    bottom: 35px;
    height: 50px;
    text-align: left;
    padding-left: 30px;
    img {
      border-radius: 17px;
      background: linear-gradient(
        100deg,
        var(--gray-lavender) -100%,
        var(--dark-brighter) 30%
      );
      backdrop-filter: blur(12.9046px);
    }
  }
  &__title {
    &-wrapper {
      display: grid;
      grid-template-columns: 80% 20%;
      grid-template-rows: repeat(2, 1fr);
      text-align: left;
      padding: 0 30px;
    }
    font-family: var(--font-medium);
    font-style: normal;
    font-weight: normal;
    color: var(--white);
    font-size: 24px;
    line-height: 32px;
    &--subtitle {
      font-family: var(--font-medium);
      font-style: normal;
      font-weight: normal;
      color: var(--white);
      font-size: 16px;
      line-height: 24px;
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
  }
  &__arrow {
    grid-column: 2 / 3;
    grid-row: 1 / 3;
    justify-self: end;
    align-self: center;
    stroke: var(--perfect-gray);
    margin-right: 4px;
  }
}
</style>
